import React from 'react';
import { useSelector } from 'react-redux';
import { COLOR_MODE } from '@/constants';

const getFillColor = ({ primitiveProps, colorSchema, logicalType }) => {
  const { background_style } = primitiveProps;

  switch (background_style?.color_mode) {
    case COLOR_MODE.DEFINED_COLOR: {
      return background_style.fill_color;
    }
    case COLOR_MODE.VARIANT_COLOR: {
      if (colorSchema) {
        return colorSchema.background_color_hex;
      }
    }
    case COLOR_MODE.WITHOUT_COLOR:
    case COLOR_MODE.VARIANT_ELEMENT_COLOR_OR_DEFINED_COLOR:
    default: {
      if (logicalType === 'hole') {
        return '#ffffff';
      } else if (background_style?.enabled) {
        return background_style.fill_color;
      } 
      return 'transparent';
    }
  }
};

const PathComponent = props => {
  const { style, className, id, primitiveProps, logicalType, svgElementClickableRef } = props;
  const { d, outline_style } = primitiveProps;
  const colorSchema = useSelector(state => state.core.colorSchema);
  const parsedStyle = JSON.parse(JSON.stringify(style));
  const styles = {
    ...parsedStyle,
    pointerEvents: className === 'decoration' ? 'none' : 'unset',
    ...(!parsedStyle.fill && { fill: getFillColor({ primitiveProps, colorSchema, logicalType }) }),
    ...(!parsedStyle.stroke && { stroke: outline_style && outline_style.enabled && outline_style.color ? outline_style.color : '#000000' }),
  };

  return <path id={id} d={d} style={styles} ref={svgElementClickableRef} className={className} />;
};

export default PathComponent;
